import VMaterialIcon from '@voly/ui-components/src/v2/icons/VMaterialIcon.jsx';
import VRadioGroupVertical from '@voly/ui-components/src/v2/VRadioGroupVertical';
import VStack from '@voly/ui-components/src/v2/VStack.jsx';
import VStackRow from '@voly/ui-components/src/v2/VStackRow.jsx';
import VText from '@voly/ui-components/src/v2/VText.jsx';
import { ReactElement, useState } from 'react';
import { translate } from 'src/app/project/features/translate/translate';
import BulkEditDialog from './BulkEditDialog';

const FLAGGED = 'flagged';
const UNFLAGGED = 'unflagged';
const FLAGGED_COLOUR = 'red.solid';
const OPTION_GAP = '3';

type TFlagOption = typeof FLAGGED | typeof UNFLAGGED;

type TBulkFlagDialogProps = {
  isFlagged: boolean;
  onClose: () => void;
  onSave: (flagged: boolean) => Promise<void>;
};

const toFlagOption = (isFlagged: boolean): TFlagOption => (isFlagged ? FLAGGED : UNFLAGGED);

const BulkFlagDialog = ({ isFlagged, onClose, onSave }: TBulkFlagDialogProps): ReactElement => {
  const [selected, setSelected] = useState<TFlagOption>(toFlagOption(isFlagged));

  const handleValueChange = ({ value }: { value: TFlagOption }): void => {
    setSelected(value);
  };

  const handleSave = (): Promise<void> => onSave(selected === FLAGGED);

  const options = [
    {
      value: FLAGGED,
      label: (
        <VStackRow gap={1}>
          <VMaterialIcon name="flag" color={FLAGGED_COLOUR} />
          {translate('flagged')}
        </VStackRow>
      ),
    },
    { value: UNFLAGGED, label: translate('unflagged') },
  ];

  return (
    <BulkEditDialog
      title={translate('change_flag_status')}
      canSave
      onClose={onClose}
      onSave={handleSave}
      body={
        <VStack gap={3} alignItems="flex-start">
          <VText textStyle="sm" fontWeight="semibold">
            {translate('red_flags')}
          </VText>
          <VRadioGroupVertical
            gap={OPTION_GAP}
            value={selected}
            options={options}
            onValueChange={handleValueChange}
          />
        </VStack>
      }
    />
  );
};

export default BulkFlagDialog;
